import { styled } from "@mui/material/styles";
/* import { Dayjs } from "dayjs"; */
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
/* import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; */
/* import AdapterDateFns from "@mui/lab/AdapterDateFns"; */
/* import LocalizationProvider from "@mui/lab/LocalizationProvider"; */
import { LocalizationProvider } from "@mui/x-date-pickers";
/* import DatePicker from "@mui/lab/DatePicker"; */
import { DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import enLocale from "date-fns/locale/en-US";
import trLocale from "date-fns/locale/tr";
import i18next from "i18next";
import { FormHelperText } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { changeLabelForDatePicker } from "../../utils";
import dayjs from "dayjs";
import { useMemo } from "react";

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#0033A1",
  },
  "& label.Mui-disabled": {
    color:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0033A1",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? "rgb(204 204 204 / 45%)" : "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },

    "&:hover fieldset": {
      borderColor: "#0033A1",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0033A1",
    },
  },
}));
interface LocaleMap {
  [key: string]: string | Locale;
}

const localeMap: LocaleMap = {
  en: enLocale,
  tr: trLocale,
};

interface MaskMap {
  [key: string]: string;
}

const maskMap: MaskMap = {
  tr: "__.__.____",
  en: "__/__/____",
};

interface DateInputProps {
  name: string;
  label: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

const DateInput = ({
  name,
  label,
  disabled,
  minDate,
  maxDate,
}: DateInputProps) => {
  const locale = i18next.language;
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const value = useMemo(() => {
    if (typeof field.value === "string") return dayjs(field.value);
    else if (
      field.value !== "" ||
      field.value !== undefined ||
      field.value !== null
    )
      return dayjs(field.value);
  }, [field.value]);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      locale={localeMap[locale]}
    >
      <DatePicker
        mask={maskMap[locale]}
        label={label}
        value={field.value}
        onChange={(newValue: any) => {
          setFieldValue(field.name, newValue);
        }}
        renderInput={(params) => (
          <CssTextField
            {...params}
            error={Boolean(meta.error)}
            fullWidth
            disabled={disabled}
          />
        )}
        maxDate={maxDate}
        clearable={true}
        disabled={disabled}
      />
      <FormHelperText style={{ marginLeft: "10px", color: "#d32f2f" }}>
        {Boolean(meta.error) ? meta.error : ""}
      </FormHelperText>
    </LocalizationProvider>
  );
};

export default DateInput;
